'use client';

import * as React from 'react';
import {
  Building2Icon,
  LinkIcon,
  SearchIcon,
  UsersIcon,
  FileTextIcon,
  CalendarIcon
} from 'lucide-react';

import { BlurFade } from '~/components/fragments/blur-fade';
import { GridSection } from '~/components/fragments/grid-section';
import { SiteHeading } from '~/components/fragments/site-heading';

const FEATURES = [
  {
    icon: <Building2Icon className="size-5 shrink-0" />,
    title: 'Bedrijven en personen gekoppeld',
    description:
      'Koppel personen eenvoudig aan bedrijven en houd de relaties overzichtelijk. Zo zie je altijd wie waar werkt en wat de context is.'
  },
  {
    icon: <SearchIcon className="size-5 shrink-0" />,
    title: 'Slim zoeken en filteren',
    description:
      'Vind snel wat je zoekt met krachtige zoek- en filteropties. Zoek op naam, functie, bedrijf of andere criteria – Emma helpt je snel verder.'
  },
  {
    icon: <UsersIcon className="size-5 shrink-0" />,
    title: 'Volledige contacthistorie',
    description:
      'Bekijk alle activiteiten, taken en notities per contact op één plek. Zo mis je nooit meer belangrijke informatie over je relaties.'
  },
  {
    icon: <LinkIcon className="size-5 shrink-0" />,
    title: 'Meerdere adressen en contactpunten',
    description:
      'Beheer verschillende adressen (hoofdkantoor, factuuradres) en contactpunten (e-mail, telefoon) per bedrijf. Alles overzichtelijk op één plek.'
  },
  {
    icon: <FileTextIcon className="size-5 shrink-0" />,
    title: 'Rijke profielinformatie',
    description:
      'Bewaar alle belangrijke details: functie, afdeling, geslacht, geboortedatum en meer. Emma helpt je om je contacten persoonlijk te benaderen.'
  },
  {
    icon: <CalendarIcon className="size-5 shrink-0" />,
    title: 'Acties direct bij de hand',
    description:
      'Maak snel taken, notities of activiteiten aan vanuit een contact. Zo blijft alles gekoppeld en overzichtelijk.'
  }
];

export function BedrijvenEnContactpersonenFeatures(): React.JSX.Element {
  return (
    <GridSection>
      <div className="container space-y-12 py-20 md:py-32">
        <SiteHeading
          badge="Unieke voordelen"
          title="Waarom Emma's contactbeheer anders is"
          description="Met Emma beheer je je relaties op een manier die écht werkt. Geen ingewikkelde systemen, gewoon overzichtelijk en praktisch."
        />

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map((feature, index) => (
            <BlurFade
              key={index}
              inView
              delay={0.1 + index * 0.1}
              className="rounded-xl border bg-card p-6 shadow-sm transition-shadow hover:shadow-md"
            >
              <div className="mb-4 flex size-12 items-center justify-center rounded-xl border bg-background text-primary">
                {feature.icon}
              </div>
              <h3 className="mb-2 text-lg font-semibold">{feature.title}</h3>
              <p className="text-muted-foreground">{feature.description}</p>
            </BlurFade>
          ))}
        </div>
      </div>
    </GridSection>
  );
}
